import React from 'react';
import { useDispatch } from 'react-redux';
import { dialogs } from '@yola/ws-sdk';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';
import SiteBackups from '../../site-backups/containers/site-backups';
import constants from '../constants';
import { useWebsiteSettingsContext } from '../context/website-settings-context';

const { tabIdentifiers } = constants;

function BackupsSection() {
  const { formValues: form } = useWebsiteSettingsContext();
  const dispatch = useDispatch();

  // Return to the current active tab with the form data kept
  const returnToCurrentTab = () => {
    dispatch(
      dialogs.actions.show(dialogTypes.WEBSITE_SETTINGS, {
        form,
        activeTabId: tabIdentifiers.BACKUPS,
      })
    );
  };

  return (
    <SiteBackups
      onBackupCreateSuccess={returnToCurrentTab}
      onCreateCancel={returnToCurrentTab}
      onRestoreCancel={returnToCurrentTab}
    />
  );
}

export default BackupsSection;
